
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/behavioral-science",
      function () {
        return require("private-next-pages/behavioral-science.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/behavioral-science"])
      });
    }
  